import React from "react";
import DatasetMetricSourceSelector, {
  type ResolvedMetricSelection,
} from "./DatasetMetricSourceSelector";
import {
  barChartMetricNeedsQuestionDetailFetch,
  buildBarChartFocusParamsFromMetric,
  isMetricEligibleForBarChart,
  metricHasPercentageResultType,
  type BarChartMetricFocusParams,
} from "@components/charts/bar-chart-config/metric-source/bar-chart-metric-utils";

export type ResolvedBarChartMetricSelection = ResolvedMetricSelection<BarChartMetricFocusParams>;

interface BarChartMetricSourceSelectorProps {
  datasetId: string;
  onResolvedChange: (selection: ResolvedBarChartMetricSelection | null) => void;
}

/** Bar Chart's Metric source picker — thin wrapper over the shared
 *  DatasetMetricSourceSelector (PRD-67 reuses this same picker for Line
 *  Chart), supplying Bar Chart's own Percentage-only eligibility and
 *  focus-param resolution. */
const BarChartMetricSourceSelector: React.FC<BarChartMetricSourceSelectorProps> = ({
  datasetId,
  onResolvedChange,
}) => (
  <DatasetMetricSourceSelector<BarChartMetricFocusParams>
    datasetId={datasetId}
    resultTypeFilter={metricHasPercentageResultType}
    isEligible={isMetricEligibleForBarChart}
    needsQuestionDetailFetch={barChartMetricNeedsQuestionDetailFetch}
    buildFocusParams={buildBarChartFocusParamsFromMetric}
    eligibilityCaption="Only metrics with a Percentage result can be used in a Bar Chart."
    noMetricsMessage="No Percentage metrics found in this dataset yet."
    onResolvedChange={onResolvedChange}
  />
);

export default BarChartMetricSourceSelector;
